import { action } from 'mobx';
import { container, singleton } from 'tsyringe';

import { ConcurrencyStore } from '../stores/concurrency/concurrency-store';

@singleton()
export class ConcurrencyStoreFacade {
  originalStore: ConcurrencyStore;

  constructor() {
    this.originalStore = container.resolve(ConcurrencyStore);
  }

  public get household() {
    return this.originalStore.household;
  }

  public get concurrencyBuymore() {
    return this.originalStore.concurrencyBuymore;
  }

  public get streamingDevices() {
    return this.originalStore.streamingDevices;
  }

  public get concurrencyPlayerErrorTtl() {
    return this.originalStore.concurrencyPlayerErrorTtl;
  }

  @action.bound
  async getConcurrencyDetails() {
    return await this.originalStore.getConcurrencyDetails();
  }

  /**
   * Get concurrency limitations
   */
  @action
  async getConcurrencyLimitations(skipTotalStreamingDevices = false) {
    return await this.originalStore.getConcurrencyLimitations(skipTotalStreamingDevices);
  }
}
